import { useEffect, useRef } from 'react'
import { Button } from '../Button/Button'
import { count, root } from './LoadMore.css'

export type LoadMoreProps = {
  onClick: () => void
  loading?: boolean
  shown: number
  total?: number
  hasMore: boolean
  label?: string
}

export function LoadMore({
  onClick,
  loading = false,
  shown,
  total,
  hasMore,
  label = 'Carregar mais',
}: LoadMoreProps) {
  const summary = total != null ? `${shown} de ${total}` : `${shown}`
  const sentinelRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const node = sentinelRef.current
    if (!node || !hasMore || loading || typeof IntersectionObserver === 'undefined') {
      return undefined
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          onClick()
        }
      },
      { rootMargin: '360px 0px' },
    )
    observer.observe(node)
    return () => {
      observer.disconnect()
    }
  }, [hasMore, loading, onClick])

  return (
    <div ref={sentinelRef} className={root}>
      {hasMore ? (
        <Button variant="secondary" size="sm" disabled={loading} onClick={onClick}>
          {loading ? 'Carregando…' : label}
        </Button>
      ) : null}
      <span className={count}>{summary}</span>
    </div>
  )
}
